import useKeyConversion from '~/composables/useKeyConversion';
import useCachedFetch from '~/composables/useCachedFetch';
import useUrlReplace from '~/composables/useUrlReplace';
import { useArticleStore } from '~/store/article';

export default function showPaywall (config) {
  const paywallUrl = `/auth/user/paywall${window.location.search}`;
  const nodeToInjectPaywall = config.nodeToInjectPaywall || document.body;
  injectPaywall();

  async function getPaywallData () {
    const { replaceUrl } = useUrlReplace();
    const useRequestUrl = useRequestURL();

    const articleProxyApi = useRuntimeConfig().public.article?.api;
    const articleStore = useArticleStore();
    const externalPropertyResult = await useCachedFetch('article').getData('', () =>
      $fetch(replaceUrl(articleProxyApi, {
        id: articleStore.currentArticle.id,
        shareToken: useRequestUrl.searchParams.get('shareToken') || '',
        paywall_debug: useRequestUrl.searchParams.get('paywall_debug') || '',
        unlockToken: useRequestUrl.searchParams.get('unlockToken') || ''
      }), {
        headers: {
          'paywall-include-metadatas': true
        }
      }), 0);
    const paywallConfigData = {
      'paywall-pids': config.pids,
      'paywall-url': config.url,
      'paywall-full-article': config.showingFullArticle,
      'paywall-referer': config.referrer,
      'paywall-access-level': config.accessLevel
    };
    const conversionExternalProperty = useKeyConversion('kebab').convertKeys(externalPropertyResult.response);
    return { ...conversionExternalProperty, ...paywallConfigData };
  }

  async function fetchPaywall () {
    const myHeaders = new Headers();
    const paywallData = await getPaywallData();
    for (const [key, value] of Object.entries(paywallData)) {
      try {
        myHeaders.append(key, value.toString());
      } catch (ex) {
        throw createError(`${ex}, ${key}, ${value}`);
      }
    }
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    try {
      const res = await fetch(paywallUrl, requestOptions);
      return await res.text();
    } catch (ex) {
      throw createError(`Error fetching paywall ${ex}`);
    }
  }

  function parsePaywall (text) {
    const parser = new DOMParser();
    return parser.parseFromString(text, 'text/html');
  }

  function newScriptNode (node) {
    const el = document.createElement(node.tagName);
    for (const attr of node.attributes) {
      el.setAttribute(attr.name, attr.value);
    }
    el.innerHTML = node.innerHTML;
    return el;
  }
  async function injectPaywall () {
    window.subPaywallShow = false;
    if (nodeToInjectPaywall && nodeToInjectPaywall.innerHTML.length > 0) {
      nodeToInjectPaywall.innerHTML = '';
    }
    const paywallText = await fetchPaywall();
    if (paywallText?.length > 0) {
      const paywallHtml = parsePaywall(paywallText);
      [...paywallHtml.querySelectorAll('#sub-paywall-response *')].forEach((el) => {
        if (el.getAttribute('data-sub-paywall-templates-include') === 'true') {
          if (el.nodeName.toLowerCase() !== 'script') {
            nodeToInjectPaywall.appendChild(el.cloneNode(true));
          }
        }
      });
      const executeAfterScriptsAreLoaded = [];
      let serverSidedScript = false;
      [...paywallHtml.querySelectorAll('#sub-paywall-response script')].forEach((script) => {
        const newScript = newScriptNode(script);
        if (newScript.innerHTML && newScript.getAttribute('data-sub-paywall-templates-include') === 'true') {
          executeAfterScriptsAreLoaded.push(newScript);
        } else {
          nodeToInjectPaywall.appendChild(newScript);
          serverSidedScript = true;
        }
      });
      //  This denotes script has been loaded
      // eslint-disable-next-line no-unmodified-loop-condition
      while (!window.subPaywallShow && serverSidedScript) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      executeAfterScriptsAreLoaded.forEach(task => nodeToInjectPaywall.appendChild(task));
    }
  }
}
